export enum CanonicalCourseChapterItemType {
  Lesson = 'lesson',
  QuestionSet = 'questionSet',
  Unknown = 'unknown',
}

export function normalizeCourseChapterItemType(
  rawType: string | null | undefined
): CanonicalCourseChapterItemType {
  const type = (rawType ?? '').trim();

  switch (type) {
    case 'lesson':
    case 'Lesson':
    case 'App\\Models\\Lesson':
    case 'App/Models/Lesson':
      return CanonicalCourseChapterItemType.Lesson;

    case 'questionSet':
    case 'QuestionSet':
    case 'App\\Models\\QuestionSet':
    case 'App/Models/QuestionSet':
    case 'pre-test':
    case 'post-test':
      return CanonicalCourseChapterItemType.QuestionSet;

    default:
      return CanonicalCourseChapterItemType.Unknown;
  }
}
